import { connect } from 'react-redux';
import { getUserPromoStack } from 'features/userpromo/actions';

import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ContentTypography from 'components/ContentTypography';
import Grid from '@material-ui/core/Grid';
import PaddedDivider from 'components/PaddedDivider';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import { darkTheme, lightTheme, palette } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ResponsiveBackgroundImg } from 'components/ResponsiveImg';
import ArrowRightIcon from 'mdi-material-ui/ArrowRight';

const PromoCard = styled(Card)`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin-left: 3vw;
  margin-right: 3vw;
  margin-bottom: 5vh;
  background: ${props =>
    !props.color1 || !props.color2
      ? palette.primary.main
      : `linear-gradient(45deg, ${props.color1} 0%, ${props.color2} 100%)`};
`;

const PromoCardContent = styled(CardContent)`
  position: relative;
  z-index: 1;
  padding: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  max-width: 600px;
`;

const PromoBackgroundImg = styled(ResponsiveBackgroundImg)`
  opacity: 0.5;
  mix-blend-mode: luminosity;
`;

const PromoImg = styled.img`
  margin: 20px;
`;

export class UserPromo extends React.PureComponent {
  componentDidMount() {
    this.props.getUserPromoStack();
  }

  render() {
    const { stack } = this.props;

    const promo = stack[_.random(0, stack.length - 1)];

    return promo ? (
      <MuiThemeProvider
        theme={promo.foreground_color === 'dark' ? lightTheme : darkTheme}
      >
        <PromoCard
          color1={promo.background_gradient.color_1}
          color2={promo.background_gradient.color_2}
          elevation={0}
        >
          <PromoCardContent>
            <Grid container justify="center" alignItems="center">
              {promo.blocks &&
                promo.blocks.map((block, idx) => (
                  <Fragment key={idx}>
                    {block.heading && (
                      <Grid item xs={12}>
                        <Typography variant={block.heading.style}>
                          {block.heading.text}
                        </Typography>
                      </Grid>
                    )}

                    {block.rich_text && (
                      <Grid item md={block.rich_text.columns} xs={12}>
                        <ContentTypography
                          theme={
                            promo.foreground_color === 'dark'
                              ? lightTheme
                              : darkTheme
                          }
                          variant="body2"
                          dangerouslySetInnerHTML={{
                            __html: block.rich_text.text
                          }}
                        />
                      </Grid>
                    )}

                    {block.horizontal_rule && (
                      <Grid item md={block.horizontal_rule.columns} xs={12}>
                        <PaddedDivider />
                      </Grid>
                    )}

                    {block.image && (
                      <Grid item xs={12}>
                        <PromoImg
                          src={block.image.image.url}
                          width={`${block.image.width}px`}
                        />
                      </Grid>
                    )}

                    {block.button && (
                      <Grid item xs={12}>
                        <Button href={block.button.url}>
                          {block.button.text} <ArrowRightIcon />
                        </Button>
                      </Grid>
                    )}
                  </Fragment>
                ))}
            </Grid>
          </PromoCardContent>
          {promo.background_image && (
            <PromoBackgroundImg
              src={promo.background_image.url}
              defaultWidth={1000}
              backgroundcolor="rgba(0,0,0,0)"
            />
          )}
        </PromoCard>
      </MuiThemeProvider>
    ) : null;
  }
}

UserPromo.propTypes = {
  stack: PropTypes.array
};

export default connect(
  state => ({
    stack: state.userPromo.stack
  }),
  { getUserPromoStack }
)(UserPromo);
